/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookOpenPlus: {
  name: 'book-open-plus';
  data: string;
} = {
  name: 'book-open-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0V7h1a1 1 0 1 0 0-2h-1V4ZM4.485 3.34A2 2 0 0 0 2 5.28v11.94a2 2 0 0 0 1.515 1.94l7 1.75c.047.011.094.021.142.03a.998.998 0 0 0 .686 0c.048-.009.095-.019.142-.03l7-1.75A2 2 0 0 0 20 17.22V12a1 1 0 1 0-2 0v5.22l-6 1.5V7h1a1 1 0 1 0 0-2h-1.877L4.485 3.34ZM10 6.78l-6-1.5v11.94l6 1.5V6.78Z" fill="currentColor"/></svg>`,
};
